// src/hooks/useDarkMode.js
import { useEffect, useState } from "react";

const STORAGE_KEY = "theme"; // "dark" | "light"

// Тёмная по умолчанию при первом заходе
export default function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "dark") return true;
      if (saved === "light") return false;
      // Нет сохранённого выбора -> включаем тёмную
      return true;
    } catch {
      return true;
    }
  });

  // Применяем класс к <html> и сохраняем выбор
  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add("dark");
      try { localStorage.setItem(STORAGE_KEY, "dark"); } catch {}
    } else {
      root.classList.remove("dark");
      try { localStorage.setItem(STORAGE_KEY, "light"); } catch {}
    }
  }, [isDark]);

  return [isDark, setIsDark];
}
